<template>
	<div class="img_container1" :style="{ '--banner-img-h': imgHeight }">
		<img class="img1" :src="bgImage" alt="中国区独家总代" />
		<div class="title_container">
			<img class="curiosis" src="../../assets/img/index/curiosis.png" />
			<div class="chn_title">
				中国区<span style="color: #FFF100;">独家</span>总代</div>
		</div>
		<div class="eng_title">Exclusive General Agent In China</div>
	</div>
</template>

<script>
	export default {
		name: 'PageBanner',
		props: {
			// 顶部横幅底图（默认 产品中心.jpg，所有页面一致）
			bgImage: {
				type: String,
				default: () => require('../../assets/img/index/产品中心.jpg')
			},
			// 桌面端（>1150px）横幅底图高度；响应式断点下由媒体查询接管
			imgHeight: {
				type: String,
				default: '450px'
			}
		}
	}
</script>

<style scoped>
	.img_container1 {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		position: relative;
		margin: 0;
	}

	.img1 {
		height: var(--banner-img-h, 450px);
		width: 100%;
	}

	.title_container {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		position: absolute;
		color: #fff;
	}

	.curiosis {
		height: 50px;
		width: 300px;
		margin-top: 10px;
	}

	.chn_title {
		color: #fff;
		font-size: 58px;
		margin-left: 30px;
		font-weight: bold;
		letter-spacing: 2px;
	}

	.eng_title {
		transform: translateY(70px);
		position: absolute;
		color: #fff;
		font-size: 20px;
		letter-spacing: 2px;
		font-family: Rany Light;
	}

	@media screen and (max-width: 1150px) {
		.title_container {
			margin-bottom: 30px;
		}

		.img1 {
			height: calc(300px + 10vw);
			width: 100%;
		}

		.chn_title {
			font-size: 2rem;
			color: #fff;
			margin-left: 30px;
			font-weight: bold;
			letter-spacing: 2px;
		}

		.curiosis {
			height: 2rem;
			width: auto;
		}

		.eng_title {
			font-size: 0.8rem;
			margin-bottom: 45px;
		}
	}

	@media screen and (max-width: 800px) {
		.img1 {
			height: calc(200px + 10vw);
			width: 100%;
		}

		.curiosis {
			width: auto;
			height: 1.1rem;
			margin-top: 2.2rem;
			margin-left: 10px;
		}

		.chn_title {
			font-size: 1.1rem;
			margin-top: 2.1rem;
			margin-left: 20px;
		}

		.eng_title {
			font-size: 0.6rem;
			margin-bottom: 5.2rem;
			letter-spacing: 1px;
		}
	}

	@media screen and (max-width: 280px) {
		.title_container {
			flex-direction: column;
			margin-right: 20px;
		}

		.chn_title {
			margin-top: 10px;
		}

		.eng_title {
			margin-top: 32px;
		}
	}
</style>
